import { GqlImageBanner } from 'types/graphql';

/**
 * Normalizes image banners by ensuring platforms is always an array
 * and schedule/timeRanges are properly structured for GraphQL mutation.
 */
export function normalizeBannersForUpdate(sortedBanners: GqlImageBanner[]): GqlImageBanner[] {
  return sortedBanners.map((banner) => ({
    ...banner,
    platforms: banner.platforms ?? [],
    schedule: banner.schedule
      ? {
          id: banner.schedule.id,
          startDate: banner.schedule.startDate,
          endDate: banner.schedule.endDate,
          timeRanges: banner.schedule.timeRanges?.map((tr) => ({
            id: tr.id,
            dayOfWeek: tr.dayOfWeek,
            startTime: tr.startTime,
            endTime: tr.endTime,
          })),
        }
      : undefined,
  }));
}
